import Column from '@components/Column';
import Header from '@components/Header';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import DeleteAll from './components/DeleteAll';
import PrepaidCardList from './components/PrepaidCardList';

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardManageActivity: {};
    }
}

const PrepaidCardManageActivity: ActivityComponentType<'PrepaidCardManageActivity'> = () => {
    const { t } = useTranslation('prepaidCard');
    return (
        <AppScreen>
            <Root fullWidth>
                <Header title={t('manage.title')} />
                <DeleteAll/>
                <PrepaidCardList/>
            </Root>
        </AppScreen>
    );
};

const Root = styled(Column)`
    background-color: var(--color-gray2);
`;

export default PrepaidCardManageActivity;
